enum NodeSize {
    SMALL = 'small',
    NORMAL = 'normal',
    LARGE = 'large',
}

export default NodeSize;
